module.exports = __webpack_public_path__ + "img/interrogation-icon.520cf7cb.svg";